// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uWzf0{overflow:hidden}.xvku4{overflow:hidden;position:relative}.hD2x0{position:absolute;top:0;left:0;right:0;z-index:10}.K8gMW{position:absolute;top:64px;left:0;right:0;padding:8px;z-index:10}.VGPmv{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0}.z08Uv{padding-top:64px;padding-bottom:72px}.x4mPS{padding-top:64px;padding-bottom:40px}.pBcSr{position:absolute;bottom:0;left:0;right:0;z-index:10}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `uWzf0`,
	"contentBox": `xvku4`,
	"headerWrapper": `hD2x0`,
	"titleWrapper": `K8gMW`,
	"contentArea": `VGPmv`,
	"contentAreaOnboarding": `z08Uv`,
	"contentAreaNoFooter": `x4mPS`,
	"footerWrapper": `pBcSr`
};
export default ___CSS_LOADER_EXPORT___;
